import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c9efc73")

_pushScopeId("data-v-0c9efc73")
const _hoisted_1 = { class: "inquriy-content-contanier" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "form-banner" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "banner",
    src: "https://websitedn.yiautos.com/channel_quotation/v5/content_banner.png"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "form-title-content" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-title-left" }, "询价信息")
], -1)
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = { class: "form-item-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "昵称", -1)
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = { class: "form-item-left" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "性别", -1)
const _hoisted_12 = { class: "radio-group" }
const _hoisted_13 = {
  key: 0,
  class: "radio-unchecked"
}
const _hoisted_14 = {
  key: 1,
  class: "radio_checked",
  src: "https://wechatdn.yiautos.com/channel_query/v1/radio_checked.png"
}
const _hoisted_15 = { class: "radio-name" }
const _hoisted_16 = { class: "form-item-left" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createTextVNode(" 上牌地点"),
  /*#__PURE__*/_createVNode("span", { class: "required-flag" }, "*")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "form-item-value"
}
const _hoisted_19 = {
  key: 1,
  class: "form-item-value-empty"
}
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = { class: "form-item-left" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createTextVNode(" 手机号码"),
  /*#__PURE__*/_createVNode("span", { class: "required-flag" }, "*")
], -1)
const _hoisted_23 = { class: "form-item" }
const _hoisted_24 = { class: "form-item-left" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createTextVNode(" 验证码"),
  /*#__PURE__*/_createVNode("span", { class: "required-flag" }, "*")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "verfify-content"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  class: "verify-right",
  src: "https://wechatdn.yiautos.com/channel_query/v1/verify_right.png"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "verify-error-desc" }, "验证通过", -1)
const _hoisted_29 = {
  key: 1,
  class: "verfify-content"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  class: "verify-right",
  src: "https://wechatdn.yiautos.com/channel_query/v1/verify_error.png"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "verify-right-desc" }, "验证失败", -1)
const _hoisted_32 = {
  key: 3,
  class: "cut-down-btn"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "form-title-content" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-title-left" }, "购车预算（必选）"),
  /*#__PURE__*/_createVNode("div", { class: "form-title-right" }, "多选")
], -1)
const _hoisted_35 = { class: "form-button-pick" }
const _hoisted_36 = {
  key: 0,
  class: "checked-img",
  src: "https://wechatdn.yiautos.com/channel_query/v2/button-check.png"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "form-title-content" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-title-left" }, "购车时间（必选）"),
  /*#__PURE__*/_createVNode("div", { class: "form-title-right" }, "单选")
], -1)
const _hoisted_38 = { class: "form-button-pick" }
const _hoisted_39 = {
  key: 0,
  class: "checked-img",
  src: "https://wechatdn.yiautos.com/channel_query/v2/button-check.png"
}
const _hoisted_40 = { class: "submit-btn-content" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "surprise-content" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "surprise-icon",
    src: "https://websitedn.yiautos.com/channel_quotation/v4/surprise.png"
  }),
  /*#__PURE__*/_createVNode("span", { class: "surprise-text" }, "点我有惊喜!"),
  /*#__PURE__*/_createVNode("div", { class: "triangle" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_intention_car_model = _resolveComponent("intention-car-model")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, { title: "秒询底价" }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                class: "form-item-value",
                placeholder: "请输入昵称",
                "placeholder-style": "color:#A2ACB1",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.nickName = $event)),
                maxlength: "20"
              }, null, 512), [
                [_vModelText, _ctx.nickName]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.genderArr, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "radio-content",
                    key: item
                  }, [
                    _createVNode("div", {
                      class: "raido-flex",
                      onClick: ($event: any) => (_ctx.checkGender(item.code))
                    }, [
                      (_ctx.gender !== item.code)
                        ? (_openBlock(), _createBlock("div", _hoisted_13))
                        : (_openBlock(), _createBlock("img", _hoisted_14)),
                      _createVNode("div", _hoisted_15, _toDisplayString(item.name), 1)
                    ], 8, ["onClick"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", {
            class: "form-item",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectCity && _ctx.selectCity(...args)))
          }, [
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              (_ctx.cityName)
                ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.cityName), 1))
                : (_openBlock(), _createBlock("div", _hoisted_19, "请选择上牌地点"))
            ]),
            _createVNode("div", null, [
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#A2ACB1"
              })
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createVNode("input", {
                class: "form-item-value",
                placeholder: "请输入手机号码",
                "placeholder-style": "color:#A2ACB1;",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mobile = $event)),
                maxlength: "11",
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mobileInput && _ctx.mobileInput(...args)))
              }, null, 544), [
                [_vModelText, _ctx.mobile]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createVNode("input", {
                class: "form-item-value-vefify bold",
                disabled: _ctx.verifySuccess,
                placeholder: "请输入验证码",
                "placeholder-style": "color:#A2ACB1",
                maxlength: "6",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.validCode = $event)),
                onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkVerifydCode && _ctx.checkVerifydCode(...args)))
              }, null, 40, ["disabled"]), [
                [_vModelText, _ctx.validCode]
              ])
            ]),
            (_ctx.hasVerify && _ctx.verifySuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _hoisted_28
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasVerify && !_ctx.verifySuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _hoisted_31
                ]))
              : _createCommentVNode("", true),
            (!_ctx.hasSendCode)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "verify-code-btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.beforeSendCode && _ctx.beforeSendCode(...args)))
                }, " 发送验证码 "))
              : (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(_ctx.times) + "s", 1))
          ])
        ]),
        _createVNode(_component_intention_car_model, {
          class: "mgt-30",
          onChangeIntention: _ctx.changeIntention
        }, null, 8, ["onChangeIntention"]),
        (_ctx.hasIntentionCar)
          ? (_openBlock(), _createBlock("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("div", _hoisted_35, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.purchaseBudgetsArr, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item,
                    class: 
                item.check ? 'button-pick-item-active' : 'button-pick-item'
              ,
                    onClick: ($event: any) => (_ctx.budgetButtonClick(index))
                  }, [
                    (item.check)
                      ? (_openBlock(), _createBlock("img", _hoisted_36))
                      : _createCommentVNode("", true),
                    _createVNode("div", null, _toDisplayString(item.name), 1)
                  ], 10, ["onClick"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_37,
        _createVNode("div", _hoisted_38, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.purchaseTimeArr, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: item.check ? 'button-pick-item-active' : 'button-pick-item',
              onClick: ($event: any) => (_ctx.timeButtonClick(index))
            }, [
              (item.check)
                ? (_openBlock(), _createBlock("img", _hoisted_39))
                : _createCommentVNode("", true),
              _createVNode("div", null, _toDisplayString(item.name), 1)
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode("div", {
          class: "submit-btn",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.verfiyFull && _ctx.verfiyFull(...args)))
        }, "获得车型报价")
      ])
    ])
  ]))
})